import { Button } from "antd";
import React from "react";
import { t } from "i18next";
import { TomTomMaps } from "../../../components/CustomForm/TomTomMaps/TomTomMaps";

export const addresseItemMapsInputs = ({
  location = "",
  maps,
  changeEdition = null,
}) => {
  const inputs = [
    {
      children: [
        {
          name: "location",
          label: t("addresseItemMapsInputs.locationLabel"),
          value: location,
          required: true,
          type: "input",
          col: 24,
        },
        {
          required: true,
          label: t("addresseItemMapsInputs.realAddressLabel"),
          name: "maps",
          value: maps,
          type: "google-adress",
          onChange: a => {
            console.log(a);
          },
          col: 24,
        },
        {
          col: 24,
          type: "component",
          name: "mapstomtom",
          noWrapper: true,
          component: ({ refForm }) => (
            <TomTomMaps keys={"maps"} refForm={refForm} />
          ),
        },
      ],
    },
  ];

  if (changeEdition !== null) {
    inputs[0].children.push({
      label: t("addresseItemMapsInputs.save"),
      type: "submit",
      size: "small",
    });

    inputs[0].children.push({
      type: "component",
      component: () => (
        <Button
          onClick={changeEdition}
          size={"small"}
          type={"primary"}
          style={{ marginRight: 10 }}
        >
          {t("addresseItemMapsInputs.cancel")}
        </Button>
      ),
    });
  }

  return inputs;
};
